<mat-sidenav-container class="chat-sidenav-container" [hasBackdrop]="false">
  <mat-sidenav
    #chatSidenav
    mode="over"
    position="end"
    class="chat-sidenav"
    mwlResizable
    [ngStyle]="sidenavStyle"
    [opened]="open()"
    [enableGhostResize]="true"
    (resizeEnd)="onResizeEnd($event)"
  >
    <div
      class="resize-handle-left"
      mwlResizeHandle
      [resizeEdges]="{ left: true }"
      ><mat-icon>drag_indicator</mat-icon></div
    >
    <app-rb-chatbot
      [embedded]="true"
      [opened]="open()"
      (closeEmitter)="toggle()"
    />
  </mat-sidenav>
</mat-sidenav-container>
